import { combineReducers } from "redux";
import { saveReducer } from "./save";
import { filterReducer } from "./filter";

export const articlesReducer = combineReducers({
  filter: filterReducer,
  save: saveReducer
});



// WEBPACK FOOTER //
// ./src/state/articles/index.js